/**
 * Main permanent products of the ecosystem.
 * Only these count toward the "owned products" tier
 * that selects the personalised subscription checkout URL.
 *
 * Each group represents ONE logical product (variants map to the same).
 */
export const MAIN_PRODUCT_GROUPS: { name: string; ids: string[] }[] = [
  { name: "Panadería Cero",  ids: ["7222660", "7418452", "7778710"] },
  { name: "Clean Bakes",     ids: ["7456362", "8061842"] },
  { name: "Repostería Cero", ids: ["7368845", "7778364"] }, // 7778364=Küchenglück (DE)
  { name: "Clean Sweets",    ids: ["7381203"] },
  { name: "Cocina Real",     ids: ["7339562", "7368977", "7381661", "7778879"] }, // 7381661=Clean Meals, 7778879=Kochglück (DE)
  { name: "GlucoPhoto",      ids: ["7330458", "7468894", "7487694"] },
  { name: "Clean Remedies",  ids: ["8073539"] },
];

/** All main product IDs flattened */
export const MAIN_PRODUCT_IDS: readonly string[] = MAIN_PRODUCT_GROUPS.flatMap((g) => g.ids);

/**
 * Count how many of the main products a user owns.
 * Duplicates (e.g. two Cocina Real variants) count as ONE product.
 */
export function countMainProducts(ownedProductIds: string[]): number {
  let count = 0;
  for (const group of MAIN_PRODUCT_GROUPS) {
    if (group.ids.some((id) => ownedProductIds.includes(id))) {
      count++;
    }
  }
  return count;
}
